export default __webpack_public_path__ + "static/media/giftbox2-error.9e91e742.svg";